import { useCallback, useEffect, useState, type CSSProperties } from 'react';
import styles from './Testimonials.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';
import { Chip } from '../shared/Chip';
import { ScriptText } from '../shared/ScriptText';
import { testimonials } from '../../data/testimonials';

const n = testimonials.length;

export function Testimonials() {
  const [page, setPage] = useState(0);

  const goNext = useCallback(() => {
    setPage((p) => (p + 1) % n);
  }, []);

  useEffect(() => {
    const mqMobile = window.matchMedia('(max-width: 640px)');
    const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    let id: ReturnType<typeof setInterval> | undefined;

    const tick = () => {
      if (id) {
        clearInterval(id);
        id = undefined;
      }
      if (!mqMobile.matches || mqReduce.matches) return;
      id = setInterval(goNext, 3000);
    };

    tick();
    mqMobile.addEventListener('change', tick);
    mqReduce.addEventListener('change', tick);
    return () => {
      mqMobile.removeEventListener('change', tick);
      mqReduce.removeEventListener('change', tick);
      if (id) clearInterval(id);
    };
  }, [goNext]);

  return (
    <SectionWrapper className={styles.section}>
      <div className={styles.header}>
        <Chip>Love Letters</Chip>
        <h2 className={`display ${styles.title}`}>
          Real couples, real <ScriptText rotate={-2}>sparks.</ScriptText>
        </h2>
      </div>

      <div className={styles.viewport}>
        <div
          className={styles.track}
          style={
            {
              ['--n' as string]: n,
              ['--page' as string]: page,
            } as CSSProperties
          }
        >
          {testimonials.map((t) => (
            <div key={t.who} className={styles.card}>
              <div className={styles.stars}>★★★★★</div>
              <p className={styles.quote}>{t.quote}</p>
              <div className={styles.author}>
                <span className={styles.who}>{t.who}</span>
                <span className={styles.years}>{t.years}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.dots} role="tablist" aria-label="Testimonial pages">
        {testimonials.map((t, i) => (
          <button
            key={t.who}
            type="button"
            role="tab"
            aria-selected={i === page}
            aria-label={`Show testimonial ${i + 1}`}
            className={`${styles.dot} ${i === page ? styles.dotActive : ''}`}
            onClick={() => setPage(i)}
          />
        ))}
      </div>
    </SectionWrapper>
  );
}
